import { createAxiosClient } from "@ntg/component-library/utilities";
import { IComparisonInfo } from "../../declarations/types";

export const getRouteHeaderComparison = async (
    csRouteID: number,
    routeId: string,
    dataAreaId: string,
): Promise<IComparisonInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IComparisonInfo[]>(
        `/RouteHeader/RouteHeaderComparisonInfoD365`,
        { keys: { csRouteID, routeId, dataAreaId } },
    );
    return response.data;
};
